import Layout from '@/layout'

const OpenPriceRouter = {
  path: '/OpenPrice',
  component: Layout,
  redirect: 'noredirect',
  name: 'OpenPrice',
  meta: {
    title: '航交所管理',
    icon: 'daohang-tongjifenxi',
    roles: []
  },
  children: [
    {
      path: 'OpenPriceBatch',
      component: () => import('@/views/cargo/v0/Price/OpenPriceBatch/index'),
      name: 'OpenPriceBatch',
      meta: { title: '航交所运价批次管理' },
      roles: ['module_OpenPriceBatch']
    },
    {
      path: 'AviationExchangePriceWarning',
      component: () => import('@/views/cargo/v0/Price/AviationExchangePriceWarning/index'),
      name: 'AviationExchangePriceWarning',
      meta: { title: '航交所运价批次预警列表' },
      roles: ['module_AviationExchangePriceWarning']
    },
    {
      path: 'OpenPriceFinal',
      component: () => import('@/views/cargo/v0/Price/OpenPriceFinal/index'),
      name: 'OpenPriceFinal',
      meta: { title: '航交所最终运价列表' },
      roles: ['module_OpenPriceFinal']
    },
    {
      path: 'AviationExchangePriceBatchConfig',
      component: () => import('@/views/cargo/v0/SystemMaintenance/aviationExchangePriceBatchConfig'),
      name: 'AviationExchangePriceBatchConfig',
      meta: { title: '航交所运价批次配置' },
      roles: ['module_AviationExchangePriceBatchConfig']
    }
  ]
}

export default OpenPriceRouter
